import type {SearchHistoryEntryDto} from 'typings/portaro.be.types';
import type SearchHistoryDataService from '../search-history-page/search-history.data-service';

const SEARCH_HISTORY_PANEL_FILL_TO_FORM_EVENT = 'search-history-panel-fill-to-form';

export class KpSearchHistoryPanelPresenter {
    public static presenterName = 'kpSearchHistoryPanelPresenter';
    private eventTarget = new EventTarget();

    /*@ngInject*/
    constructor(private searchHistoryDataService: SearchHistoryDataService) {
    }

    public async getSearchHistory(): Promise<SearchHistoryEntryDto[]> {
        return this.searchHistoryDataService.getAll();
    }

    public dispatchFillToFormEvent(search: SearchHistoryEntryDto) {
        this.eventTarget.dispatchEvent(new CustomEvent<SearchHistoryEntryDto>(SEARCH_HISTORY_PANEL_FILL_TO_FORM_EVENT, {detail: search}));
    }

    public registerFullToFormEventHandler(handler: (event: CustomEvent<SearchHistoryEntryDto>) => void): () => void {
        this.eventTarget.addEventListener(SEARCH_HISTORY_PANEL_FILL_TO_FORM_EVENT, handler);

        return () => {
            this.eventTarget.addEventListener(SEARCH_HISTORY_PANEL_FILL_TO_FORM_EVENT, handler);
        }
    }
}